module.exports = __webpack_public_path__ + "img/CompliSpace.Logo.6c946623.png";